import { withInstall } from '@vuesax-plus/utils'
import Radio from './src/radio.vue'

export const VsRadio = withInstall(Radio)
export default VsRadio

export * from './src/radio'
